import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { BoldHeading } from "../../Components/CustomStyles";
import SignupForm from "../LoginPage/Components/SignupForm";
import { getProfileRequest } from "../../Redux/actions/auth";

const EditPage = () => {
  const dispatch = useDispatch();
  const [openCalendar, setOpenCalendar] = useState(false);
  const { isLoading } = useSelector((state) => state.home);
  const { profile } = useSelector((state) => state.auth);
  const closeModal = () => setOpenCalendar(false);
  const openModal = () => setOpenCalendar(true);

  useEffect(() => {
     dispatch(getProfileRequest());
  }, []);

  return (
    <Container>
      <BoldHeading>Your Info</BoldHeading>
      <SignupForm
        isEditPage={true}
        profile={profile}
        handleCalendar={openModal}
        openCalendar={openCalendar}
        closeModal={closeModal}
        loading={isLoading}
      />
    </Container>
  );
};

export default EditPage;
